<template>
  <multiselect id="storage_asset_selector"
               v-model="selected_storage_asset"
               :loading="loading_storage"
               :options="storage_assets"
               :searchable="true"
               :internal-search="false"
               :hide-selected="true"
               placeholder="Select a Storage Asset..."
               label="name"
               track-by="name"
               :show-labels="false"
               @select="storageAssetSelected"
               @search-change="search => assetLoader(search)">
    <template #option="props">
      <div class="kt-widget4">
        <div class="kt-widget4__item">
          <div class="kt-widget4__img kt-widget4__img--logo">
            <img src="" alt="">
          </div>
          <div class="kt-widget4__info">
            <span class="kt-widget4__title">{{ props.option.name }}</span><br>
          </div>
          <span class="kt-widget4__ext">
            <span class="kt-widget4__number">{{ formatFileSize(props.option.file_size) }}</span>
          </span>
        </div>
      </div>
    </template>
  </multiselect>
</template>

<script>
import {
  formatBytes,
} from 'Helpers/formatters';

import ldDebounce from "lodash/debounce";

export default {
  data() {
    return {
      storage_assets: [],
      selected_storage_asset: null,
      loading_storage: false,
      assetLoader: ldDebounce(this.getStorage, 250),
    };
  },
  mounted() {
    // When mounted, grab the first lot of storage assets.
    this.getStorage();
  },
  methods: {
    storageAssetSelected(option) {
      EventBus.$emit("storage_asset_selected", option);
    },
    formatFileSize(size) {
      return formatBytes(size, 2);
    },
    // This method is more or less a duplicate of
    async getStorage(name, unused_value = null) {
      try {
        this.loading_storage = true;

        const url = new URL(`${document.location.origin}/api/v1/storage`);
        const params = {
          filters: name ? `name:ct:${name}|original_name:ct:${name}` : undefined,
          per_page: `${name ? 400 : 50}`,
          unused: unused_value ? `${unused_value}` : undefined,
          sort: 'updated_at|desc',
        };
        for (const [key, value] of Object.entries(params).filter(param => param[1])) {
          url.searchParams.append(key, value);
        }

        this.storage_assets = (await axios.get(url.href)).data.data;
        this.loading_storage = false;
      } catch (err) {
        this.storage_items = [];
        this.handleAxiosError(err);
        this.loading_storage = false;
      }
    },
  },
};
</script>
